import CardActionArea from '@material-ui/core/CardActionArea';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconMessage from 'components/Shared/IconMessage';
import React, { DragEvent, memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Button, { IProps as IPropsButton } from './Button';
import { ReactComponent as UploadIcon } from 'assets/icons/upload.svg';
import SvgIcon from '@material-ui/core/SvgIcon';
import CardMedia from '@material-ui/core/CardMedia';

interface IProps extends IPropsButton {
  loading: boolean;
  draggingOver: boolean;
  droppable?: boolean;
  className?: string;
  imageURL?: string;
  onDropFile: (event: DragEvent<any>) => void;
  onDragIn: (event: DragEvent<any>) => void;
  onDragOut: (event: DragEvent<any>) => void;
  fileSelected: (file: File) => void;
}

const useStyles = makeStyles(theme => ({
  dropArea: {
    border: '2px dashed #00000029',
    borderRadius: theme.spacing(1),
    height: theme.spacing(16)
  },
  dropAreaProgress: {
    marginTop: 60
  },
  dropAreaDragging: {
    background: '#fff10a1f'
  },
  dropAreaDraggingChildren: {
    pointerEvents: 'none',
    height: '100%',
    width: '100%'
  },
  media: {
    height: '100%',
    width: '100%',
    backgroundSize: 'contain'
  },
  actionArea: {
    height: '100%',
    display: 'flex'
    // minHeight: theme.spacing(16)
  }
}));

const Icon = () => <SvgIcon style={{ fontSize: 50 }} component={UploadIcon} />;

const Area = memo((props: IProps) => {
  const { className, draggingOver, loading, onDropFile, onDragIn, onDragOut, handleSelectImage, imageURL } = props;
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.dropArea, className, { [classes.dropAreaDragging]: draggingOver })}
      onDrop={onDropFile}
      onDragOver={onDragIn}
      onDragLeave={onDragOut}
    >
      {loading && <CircularProgress color='secondary' size={50} className={classes.dropAreaProgress} />}

      {!loading && (
        <CardActionArea onClick={handleSelectImage} className={classes.actionArea}>
          <div className={classes.dropAreaDraggingChildren}>
            {imageURL && <CardMedia image={imageURL} className={classes.media} />}
            {!imageURL && <IconMessage icon={Icon} message='Arraste e solte ou selecione um arquivo.' />}
          </div>
          <div className={draggingOver ? classes.dropAreaDraggingChildren : null}>
            <Button {...props} hideButton />
          </div>
        </CardActionArea>
      )}
    </div>
  );
});

export default Area;
